import Button from "@material-tailwind/react/Button"
import Icon from "@material-tailwind/react/Icon"

const AdminNavbar = ({ setShowSidebar }) => {
  return (
    <div className='bg-gray-900 lg:ml-64 py-6 px-3 sticky top-0 z-40'>
      <div className='container min-w-full mx-auto flex items-center justify-between lg:pr-8 lg:pl-10'>
        <div className='lg:hidden'>
          <Button
            color='transparent'
            buttonType='link'
            size='lg'
            iconOnly
            rounded
            ripple='light'
            onClick={() => setShowSidebar("left-0")}>
            <Icon name='menu' size='2xl' color='white' />
          </Button>
        </div>

        <div className='flex justify-center items-center w-full'>
          <h4 className='uppercase text-white text-sb font-semibold tracking-wider mt-1'>
            CB DESARROLLO CONTROL DE ACCESOS
          </h4>
        </div>
      </div>
    </div>
  )
}

export default AdminNavbar
